export const API_BASE_URL = process.env.REACT_APP_PRODUCTION_API_URL;
export const GOOGLE_OAUTH_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;

export const MONTHLY_FORM_PRICE = 3.99;
export const ANNUAL_FORM_PRICE = (MONTHLY_FORM_PRICE * 10).toFixed(2);
